<div class="drawer">
  <input id="my-drawer" #drawer type="checkbox" class="drawer-toggle" />
  <div class="drawer-content">
    <!-- Page content here -->
    <main class="grid md:grid-cols-[280px_3fr] min-h-screen relative">
      <app-dashboard-sidebar class="hidden md:block sticky top-0 left-0 h-dvh" />
      <section class="overflow-hidden">
        <header class="container border-b-2  border-b-base-300 flex items-center justify-between">
          <h1 class="text-4xl font-heading text-balance font-extrabold text-accent">{{currentTab()}}</h1>
          <div class="flex items-center gap-4">
            <app-theme-button />
            <label for="my-drawer" class="btn btn-ghost btn-circle drawer-button md:hidden">
              <ng-icon name="faSolidBarsStaggered" size="24" />
            </label>
          </div>

        </header>
        <router-outlet />
      </section>
    </main>
  </div>
  <div class="drawer-side">
    <label for="my-drawer" aria-label="close sidebar" class="drawer-overlay"></label>
    <app-dashboard-sidebar [drawerToggler]="drawer" class="w-80" />
  </div>
</div>